import { HttpRequest3fsc4149kgwfg as HttpRequest } from './HttpRequest.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DefaultHttpRequestClass;
function DefaultHttpRequest() {
  if (DefaultHttpRequestClass === VOID) {
    class $ {
      constructor(call, data) {
        this.o5x_1 = call;
        this.p5x_1 = data.i5o_1;
        this.q5x_1 = data.h5o_1;
        this.r5x_1 = data.k5o_1;
        this.s5x_1 = data.j5o_1;
        this.t5x_1 = data.m5o_1;
      }
      v5l() {
        return this.o5x_1;
      }
      ww() {
        return this.v5l().ww();
      }
      w5l() {
        return this.p5x_1;
      }
      x5l() {
        return this.q5x_1;
      }
      p2q() {
        return this.r5x_1;
      }
      u54() {
        return this.s5x_1;
      }
      p5l() {
        return this.t5x_1;
      }
    }
    initMetadataForClass($, 'DefaultHttpRequest', VOID, VOID, [HttpRequest()]);
    DefaultHttpRequestClass = $;
  }
  return DefaultHttpRequestClass;
}
//region block: exports
export {
  DefaultHttpRequest as DefaultHttpRequest19v463zllbymg,
};
//endregion

//# sourceMappingURL=DefaultHttpRequest.mjs.map
